import styled from 'styled-components'
import { IconButton as IconButtonComponent } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: ${myPalette.aliceBlue.main};
`

export const IconButton = styled(IconButtonComponent)`
  position: relative;
  z-index: 1;
  color: ${myPalette.white.main};
  border-radius: 100%;
  padding: 10px;
  cursor: pointer;

  ion-icon {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background-color: ${myPalette.dark.buttonBackBg};
  }
`

export const MainBlock = styled.div`
  text-align: center;
  width: 100%;

  .fade-back-enter {
    opacity: 0;
    transform: translateX(-100%);
  }
  .fade-back-enter-active {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-back-exit {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-back-exit-active {
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-back-enter-active,
  .fade-back-exit-active {
    transition: opacity 300ms, transform 300ms;
  }

  .fade-next-enter {
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-next-enter-active {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-next-exit {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-next-exit-active {
    opacity: 0;
    transform: translateX(-100%);
  }
  .fade-next-enter-active,
  .fade-next-exit-active {
    transition: opacity 300ms, transform 300ms;
  }
`
